<template>
  <v-row no-gutters
         class="main-container std-background-grey-1 text-open std-border-radius std-container-shadow-dense">
    <!-- inicio enfermedad-->
    <v-col cols="4"
           class="px-2 std-background-blue-2 std-text-white-1 d-flex align-center flex-wrap std-border-left-radius">
      <div>{{disease}}</div>
    </v-col>
    <!-- fin enfermedad-->

    <!-- inicio indicadores de dosis-->
    <v-col cols="6"
           style="position: relative"
           class="full-height d-flex align-center justify-center">
      <div class="pl-2 text-open-xs font-italic std-text-gray-2"
           style="position: absolute; bottom: 2px; left: 0">{{freq}}</div>
      <div class="d-flex check-container align-center col-12 pa-0">
        <div class="col-2 pa-0 d-flex align-center justify-center">
        <i class="std-icon success-icon "></i>
        </div>
        <div class="col-2 pa-0 d-flex align-center justify-center">
          <i class="std-icon next-icon "></i>
        </div>
        <div class="col-2 pa-0 d-flex align-center justify-center">
          <i class="std-icon success-icon">
          </i>
        </div>
        <div class="col-2 pa-0 d-flex align-center justify-center">
          <i class="std-icon success-icon"></i>
        </div>
        <div class="col-2 pa-0 d-flex align-center justify-center">
          <i class="std-icon empty-icon"></i>
        </div>
        <div class="col-2 pa-0 d-flex align-center justify-center">
          <i class="std-icon empty-icon"></i>
        </div>
      </div>
    </v-col>
    <!-- fin indicadores de dosis-->

    <!-- inicio dosis-->
    <v-col cols="2"
           class="d-flex align-center justify-center std-text-blue-2 font-weight-bold flex-wrap">
      <div class="std-border-right-radius">
        <div class="text-center col-12 pa-0">{{dosis}} ml</div>
        <div class="text-center col-12 pa-0">por KG</div>
      </div>
    </v-col>
    <!-- fin dosis-->

  </v-row>
</template>

<script>
    export default {
        name: "VaccineCard",
        props: ['disease', 'dosis', 'freq'],
    }
</script>

<style scoped>
  .main-container {
    height: 90px;
  }

  .success-icon {
    background: url("../assets/cow-profile/success-check.svg") no-repeat;
    height: 32px;
    width: 32px;
  }

  .empty-icon {
    background: url("../assets/cow-profile/check-empty.svg") no-repeat;
    height: 32px;
    width: 32px;
  }

  .next-icon {
    background: url("../assets/cow-profile/check-next.svg") no-repeat;
    height: 48px;
    width: 48px;
  }

  .check-container {
    height: 48px;
  }

  .text-open {
    font-family: "Open Sans", sans-serif;
    font-size: 1rem;
  }

  .text-open-xs {
    font-family: "Open Sans", sans-serif;
    font-size: .75rem;
  }

</style>